import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const [reference, setReference] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setReference(data.reference);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "failed" || data.payment_status === "expired") { setStatus("failed"); return; }
      } catch (e) {
        if (process.env.NODE_ENV === "development") console.error("Payment status poll failed:", e);
      }
      attempts.current += 1;
      if (attempts.current > 15) { setStatus("failed"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div><Navbar />
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        {status === "checking" && (<><Loader2 className="animate-spin mx-auto text-[#008057]" size={48} /><h1 className="font-display text-2xl font-bold text-[#03281B] mt-6">Confirming your payment...</h1><p className="text-slate-600 mt-2">Please wait, this only takes a moment.</p></>)}
        {status === "paid" && (
          <div data-testid="payment-success">
            <CheckCircle2 className="mx-auto text-[#008057]" size={64} />
            <h1 className="font-display text-3xl font-extrabold text-[#03281B] mt-6">Payment Confirmed!</h1>
            <p className="text-slate-600 mt-2">Your registration is confirmed. A confirmation email is on its way.</p>
            <button onClick={() => navigate(`/confirmation/${reference}`)} className="mt-8 rounded-full bg-[#008057] text-white px-8 py-3 font-bold">View Confirmation</button>
          </div>
        )}
        {status === "failed" && (
          <div data-testid="payment-failed">
            <XCircle className="mx-auto text-red-500" size={64} />
            <h1 className="font-display text-2xl font-bold text-[#03281B] mt-6">Payment Not Confirmed</h1>
            <p className="text-slate-600 mt-2">We couldn't confirm your payment yet. If you completed it, your confirmation email will follow shortly.</p>
            {reference && <button onClick={() => navigate(`/confirmation/${reference}`)} className="mt-6 rounded-full border-2 border-[#008057] text-[#008057] px-6 py-2.5 font-bold">Check Registration Status</button>}
          </div>
        )}
      </div>
    </div>
  );
}
